// Stale-after-save sweep (PR #648) — shared query keys for the deal-flow
// Escalations queue (EscalationsPage list + detail drawer). Every mutation
// that creates an EscalationRecord (criteria item, certification, intake
// checklist item, document request) invalidates `all` so the queue picks up
// the new row without a manual refresh.

import type { EscalationListQuery } from "@/api/dealFlow/types";

export const escalationKeys = {
  all: ["deal-flow", "escalations"] as const,
  list: (query: EscalationListQuery) =>
    [...escalationKeys.all, "list", query] as const,
  detail: (id: string | null) => [...escalationKeys.all, "detail", id] as const,
};
